/**
 * Normalize a US phone number to E.164 format (+1XXXXXXXXXX)
 * Accepts formats: (555) 123-4567, 555-123-4567, 555.123.4567, 5551234567, etc.
 */
export const normalizePhoneNumber = (phone: string): string | null => {
  if (!phone) return null;

  // Strip all non-digit characters
  const digits = phone.replace(/\D/g, "");

  // Handle 10 digits (no country code)
  if (digits.length === 10) {
    return `+1${digits}`;
  }

  // Handle 11 digits starting with 1 (US country code included)
  if (digits.length === 11 && digits.startsWith("1")) {
    return `+${digits}`;
  }

  return null; // Invalid
};

/**
 * Format E.164 phone for display: +15551234567 -> (555) 123-4567
 */
export const formatPhoneForDisplay = (e164Phone: string): string => {
  if (!e164Phone) return "";
  const digits = e164Phone.replace(/\D/g, "");
  const local = digits.slice(-10); // Last 10 digits
  if (local.length !== 10) return e164Phone; // Return as-is if not valid
  return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
};

/**
 * Validate phone number can be normalized
 */
export const isValidUSPhone = (phone: string): boolean => {
  return normalizePhoneNumber(phone) !== null;
};
